<div [ngClass]="class"
     (click)="OnClick($event)"
     [ngStyle]="style"
     [class.hidden]="hidden"
     [class.disabled]="disabled"
     [innerHtml]="value | rtiSafeHtml">
</div>
